const eigenmietwertPost = {
  slug: 'eigenmietwert',
  date: '2026-03-15',
  de: {
    title: 'Eigenmietwert',
    category: 'Steuern / Schweiz',
    excerpt:
      'Die beschlossene Abschaffung des Eigenmietwerts wird die steuerliche Behandlung von selbstgenutztem Wohneigentum in der Schweiz spürbar verändern.',
    lead:
      'Am 28. September 2025 wurde die Abschaffung des Eigenmietwerts beschlossen. Der genaue Umsetzungsfahrplan ist zwar noch offen, doch schon heute ist klar, dass sich die steuerliche Behandlung von selbstgenutztem Wohneigentum deutlich verändern wird. Nach heutigem Stand wird mit einer Übergangsfrist von mindestens zwei Jahren gerechnet, womit eine Umsetzung frühestens ab Anfang 2028 realistisch erscheint.',
    sections: [
      {
        heading: 'Ein Systemwechsel mit Folgen',
        paragraphs: [
          'Bislang konnten Hypothekarzinsen vom Einkommen abgezogen werden. Gleichzeitig musste aber der Eigenmietwert als fiktives Einkommen versteuert werden.',
          'Gerade bei höherer Verschuldung ergaben sich daraus steuerliche Vorteile.',
          'Mit der Abschaffung des Eigenmietwerts entfällt künftig diese Besteuerung auf selbstgenutzten Erst- und Zweitimmobilien.',
          'Gleichzeitig sollen bei selbstbewohntem Wohneigentum die Abzüge für Unterhaltskosten und Hypothekarzinsen weitgehend wegfallen.',
          'Für Ersterwerber ist beim Abzug von Hypothekarzinsen eine befristete Ausnahme vorgesehen.'
        ]
      },
      {
        heading: 'Was Eigentümer jetzt prüfen sollten',
        paragraphs: [
          'Wer Sanierungen plant, sollte die steuerlichen Folgen frühzeitig prüfen.',
          'Ein Vorziehen kann sinnvoll sein, weil gewisse werterhaltende Unterhaltskosten heute noch abzugsfähig sind, nach dem Systemwechsel aber bei selbstgenutzten Liegenschaften voraussichtlich wegfallen.',
          'Das ist der Hauptgrund, weshalb sich Eigentümer schon vor der Umsetzung mit Sanierungsarbeiten beschäftigen sollten: Nicht weil jede Renovation automatisch besser wird, sondern weil gewisse Abzüge nur im heutigen System noch nutzbar sind.',
          'Dazu können je nach Konstellation auch energetische und umweltschonende Massnahmen gehören. Auf Bundesebene sollen diese Abzüge künftig weitgehend entfallen, während die Kantone teilweise Spielraum behalten könnten.',
          'Das gilt jedoch nicht für alle Investitionen. Steuerlich begünstigt sind grundsätzlich nur werterhaltende Arbeiten wie Reparaturen, Instandstellungen oder der Ersatz bestehender Teile durch Gleichwertiges.',
          'Wertvermehrende Investitionen wie Anbauten, grössere Umbauten oder Luxusausstattungen sind schon heute nicht abzugsfähig.',
          'Auch kleinere Arbeiten, etwa ein Küchenersatz, sollten deshalb nicht isoliert betrachtet werden. Entscheidend ist, ob die Massnahme steuerlich noch vom heutigen System profitiert oder ob der Vorteil nach der Reform wegfällt.'
        ]
      },
      {
        heading: 'Vermietung, Zweitwohnungen und offene Punkte',
        paragraphs: [
          'Für vermietete Liegenschaften bleiben Unterhaltskosten grundsätzlich abzugsfähig. Auch der Abzug von Hypothekarzinsen bleibt dort im Grundsatz erhalten, allerdings nur anteilig.',
          'Wer ausschliesslich vermietet, bleibt daher vergleichsweise neutral betroffen. Wer eine Liegenschaft ausschliesslich selbst nutzt, verliert diese Abzüge künftig weitgehend.',
          'Zusätzlich können Kantone mit vielen Zweitwohnungen künftig eine Objektsteuer auf Zweitwohnungen einführen, um Steuerausfälle abzufedern.',
          'Noch offen bleibt, wie sich der Wegfall einzelner Abzüge im Detail auswirkt, insbesondere bei Energiesparmassnahmen, bei der Grundstückgewinnsteuer und bei der konkreten Ausgestaltung der kantonalen Regeln.'
        ]
      },
      {
        heading: 'Soll man jetzt amortisieren?',
        paragraphs: [
          'Die Abschaffung des Eigenmietwerts bedeutet nicht automatisch, dass eine schnelle oder vollständige Amortisation immer die beste Lösung ist.',
          'Wer Kapital für die Rückzahlung der Hypothek einsetzt, bindet dieses Vermögen im Objekt und verliert unter Umständen Flexibilität und Liquidität.',
          'Gerade bei jüngeren Eigentümern, bei geplanten Investitionen oder im Hinblick auf unerwartete Ausgaben kann es sinnvoller sein, Reserven zu behalten und die Entscheidung sauber zu rechnen, statt nur auf den wegfallenden Abzug von Hypothekarzinsen zu reagieren.'
        ]
      }
    ],
    takeaway: {
      title: 'Fazit',
      quote: 'Schuldenfreie Eigenheimbesitzer profitieren tendenziell.',
      points: [
        'Hochverschuldete Eigentümer verlieren bisherige steuerliche Vorteile.',
        'Vermieter bleiben weitgehend neutral.',
        'Eigentümer mit älteren oder sanierungsbedürftigen Objekten sollten anstehende Unterhaltsarbeiten frühzeitig steuerlich prüfen.',
        'Insgesamt wird das System einfacher und fördert langfristig den Schuldenabbau.'
      ],
      note: 'Dieser Beitrag ersetzt keine persönliche und individuelle Beratung anhand Ihrer konkreten Situation.'
    }
  },
  en: {
    title: 'Imputed Rental Value',
    category: 'Taxes / Switzerland',
    excerpt:
      'The abolition of imputed rental value will significantly change the tax treatment of owner-occupied residential property in Switzerland.',
    lead:
      'On September 28, 2025, the abolition of imputed rental value was approved. The exact implementation timeline is still open, but the direction is already clear: the tax logic for owner-occupied homes is changing in a meaningful way. Based on the current discussion, a transition period of at least two years is expected, which makes an effective date no earlier than the beginning of 2028 a realistic assumption.',
    sections: [
      {
        heading: 'A system shift with practical consequences',
        paragraphs: [
          'Under the current system, mortgage interest could be deducted from income tax. In return, owner-occupiers had to tax an imputed rental value as fictional income.',
          'In more highly leveraged situations, that often created a tax advantage.',
          'Once the imputed rental value disappears, owner-occupiers will no longer have to tax fictional income on self-used primary and secondary homes.',
          'At the same time, maintenance deductions and mortgage-interest deductions for owner-occupied homes are expected to disappear to a large extent.',
          'A temporary exception is planned for first-time buyers.'
        ]
      },
      {
        heading: 'What owners should review now',
        paragraphs: [
          'Anyone planning renovation work should review the tax implications early.',
          'Bringing certain projects forward may make sense because qualifying maintenance costs are still deductible today, while these deductions are expected to disappear for owner-occupied homes after the reform.',
          'That is the main reason to think about renovation timing now: not because every project becomes automatically better, but because some tax benefits may only exist under the current system.',
          'This can also matter for energy-efficiency or environmentally focused measures. At federal level, these deductions are expected to narrow significantly, while the cantons may still retain some room for their own rules.',
          'This does not apply to every type of spending. Only value-preserving work such as repairs, upkeep, and replacement with an equivalent standard is generally tax-deductible.',
          'Value-enhancing investments are typically not. The same logic applies to smaller maintenance work such as replacing a kitchen.'
        ]
      },
      {
        heading: 'Rental property, second homes, and open points',
        paragraphs: [
          'For rented properties, maintenance costs remain deductible in principle. Mortgage interest also remains deductible there, although on a proportional basis.',
          'Owners who only rent out property therefore remain in a comparatively neutral position. Owners who only live in their own home will lose these deductions to a large extent.',
          'In addition, cantons with many second homes may introduce a property-based tax on second homes to offset tax losses.',
          'Important details are still unresolved. This includes how the loss of certain deductions will interact with energy-saving measures, real estate capital gains tax, and the final cantonal implementation.'
        ]
      },
      {
        heading: 'Should owners amortize now?',
        paragraphs: [
          'The upcoming reform does not automatically mean that rapid or full mortgage repayment is the right move.',
          'Anyone using available capital to reduce debt ties more wealth to the property and may reduce financial flexibility at the wrong moment.',
          'A careful review is usually more useful than a reflex decision. Liquidity reserves, planned investments, and the expected return on capital all matter alongside the tax effect.'
        ]
      }
    ],
    takeaway: {
      title: 'Takeaway',
      quote: 'Debt-free homeowners tend to benefit.',
      points: [
        'Highly leveraged owners lose tax advantages.',
        'Landlords remain broadly neutral.',
        'Owners of older or renovation-heavy properties should review planned maintenance work early.',
        'The system becomes simpler and encourages long-term debt reduction.'
      ],
      note: 'This post does not replace personal advice based on your specific situation.'
    }
  }
};

export default eigenmietwertPost;
